import { Col, DatePicker, Row } from 'antd'
import { GetFieldDecoratorOptions, WrappedFormUtils } from 'antd/lib/form/Form'
import moment from 'moment'
import React, { useState } from 'react'
import { FormItemProps } from 'antd/lib/form'
import { DatePickerProps } from 'antd/lib/date-picker/interface'
import { ColProps, RowProps } from 'antd/lib/grid'
import { O2OFormItem } from '../../../shares/O2OFormItem'
import './index.scss'

type TFormDatePickerCustom = {
  // --- FORM WRAPPED (Parent) ---
  form: WrappedFormUtils

  // --- VALUE & FIELD FORM.ITEM ---
  fieldEndTime: string
  fieldStartTime: string
  startTime?: moment.Moment | number
  endTime?: moment.Moment | number

  // --- PROPS CUSTOM ANTD ---
  colProps?: ColProps
  rowProps?: RowProps
  getFieldDecoratorStartTime?: GetFieldDecoratorOptions
  getFieldDecoratorEndTime?: GetFieldDecoratorOptions
  formItemStartTimeProps?: FormItemProps
  formItemEndTimeProps?: FormItemProps
  datePickerStartTimeProps?: DatePickerProps
  datePickerEndTimeProps?: DatePickerProps
}

export const FormDatePickerCustom = (props: TFormDatePickerCustom) => {
  const { getFieldDecorator, getFieldValue } = props.form
  const [endOpen, setEndOpen] = useState<boolean>(false)

  const startTime = getFieldValue(props.fieldStartTime);
  const endTime = getFieldValue(props.fieldEndTime);

  const handleStartOpenChange = (open: boolean) => {
    if (!open) setEndOpen(true)
  };

  const handleEndOpenChange = (open: boolean) => {
    setEndOpen(open)
  }

  const disabledStartDate = (startTime: moment.Moment | null) => {
    if (!startTime || !endTime) return false;
    return startTime.valueOf() > endTime.valueOf();
  };

  const disabledEndDate = (endTime: moment.Moment | null) => {
    if (!endTime || !startTime) return false;
    return endTime.valueOf() <= startTime.valueOf();
  };

  return (
    <Row type='flex' gutter={[8, 8]} {...props.rowProps}>
      <Col xs={24} style={{ display: 'flex', alignItems: 'center', gap: 15, ...props.colProps?.style }} {...props.colProps}>
        <O2OFormItem style={{ flex: 1 }} help='' {...props.formItemStartTimeProps}>
          {getFieldDecorator(props?.fieldStartTime, {
            initialValue: moment(props.startTime).startOf('day'),
            ...props.getFieldDecoratorStartTime
          })(
            <DatePicker
              onOpenChange={handleStartOpenChange}
              placeholder='Start time'
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{ defaultValue: moment('00:00:00', 'HH:mm:ss') }}
              disabledDate={disabledStartDate}
              style={{ width: "100%" }}
              {...props?.datePickerStartTimeProps}
            />
          )}
        </O2OFormItem>

        <O2OFormItem style={{ flex: 1 }} help='' {...props.formItemEndTimeProps}>
          {getFieldDecorator(props.fieldEndTime, {
            initialValue: props?.endTime ? moment(props?.endTime) : moment(props?.endTime).add(1, 'day').endOf('day'),
            ...props.getFieldDecoratorEndTime
          })(
            <DatePicker
              open={endOpen}
              placeholder='End time'
              format="YYYY-MM-DD HH:mm:ss"
              showTime={{ defaultValue: moment('23:59:59', 'HH:mm:ss') }}
              onOpenChange={handleEndOpenChange}
              disabledDate={disabledEndDate}
              style={{ width: "100%" }}
              {...props?.datePickerEndTimeProps}
            />
          )}
        </O2OFormItem>
      </Col>
    </Row>
  )
}
